import { render } from "./InvoicesView.vue?vue&type=template&id=f284c3c4&scoped=true&ts=true"
import script from "./InvoicesView.vue?vue&type=script&lang=ts"
export * from "./InvoicesView.vue?vue&type=script&lang=ts"

import "./InvoicesView.vue?vue&type=style&index=0&id=f284c3c4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f284c3c4"]])

export default __exports__